import { MdDeleteForever } from 'react-icons/md'

const Note = ({ id, text, date, bgCol, handleDeleteNote }) => {
    return (
        <div style={{backgroundColor: `${bgCol}`}} id={id}className="note">
            <span>{text}</span>
            <div className="note-footer">
                <small>{date}</small>
                <MdDeleteForever onClick={ () => handleDeleteNote(id) } className="delete-icon" size="1.3em"/>
            </div>
        </div>
    )
}

export default Note;